export default function VideoDisplayTitle({ title }: { title?: string }) {
  return (
    <span className="absolute z-10 left-0 bottom-0 bg-slate-700/50 p-2 text-sm text-white rounded-xl">
      {title}
    </span>
  );
}
